import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Collapse,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography
} from '@mui/material';

// project imports

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import NavItem from '../NavItem';
// ==============================|| SIDEBAR MENU LIST COLLAPSE ITEMS ||============================== //

function NavCollapse({ menu, level, openCollapse, setOpenCollapse }) {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const location = useLocation();

    const open = openCollapse === menu.id;
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        const isChildActive = menu.children?.some(
            (child) => child.url && location.pathname.startsWith(child.url)
        );

        if (isChildActive) {
            setSelected(menu.id);
        }
    }, [location.pathname, menu.children, menu.id]);

    const handleClick = () => {
        setOpenCollapse(open ? null : menu.id);
    };

    const menus = menu.children?.map((item, index) => {
        switch (item.type) {
            case 'collapse':
                return <NavCollapse key={item.id} menu={item} level={level + 1} />;

            case 'item':
                return <NavItem key={item.id} item={item} level={level + 1} />;

            case 'divider':
                return <Box key={index} />;

            default:
                return (
                    <Typography
                        key={item.id || index}
                        variant="h6"
                        color="error"
                        align="center"
                    >
                        Menu Items Error
                    </Typography>
                );
        }
    });

    const Icon = menu.icon;
    const menuIcon = menu.icon ? (
        <Icon
            strokeWidth={1.5}
            size="1.3rem"
            style={{ marginTop: 'auto', marginBottom: 'auto' }}
        />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: open ? 8 : 6,
                height: open ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    return (
        <>
            <ListItemButton
                sx={{
                    alignItems: 'flex-start',
                    backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                    py: level > 1 ? 1 : 1.25,
                    pl: `${level * 24}px`
                }}
                selected={open}
                onClick={handleClick}
            >
                <ListItemIcon
                    className="sidebar-itemNav"
                    sx={{
                        my: 'auto',
                        minWidth: !menu?.icon ? 18 : 36,
                        color: open ? 'primary.main' : '#ffffff',
                        '& svg': {
                            width: '1.3rem',
                            height: '1.3rem',
                            display: 'block',
                            '& *': {
                                fill: 'currentColor',
                                stroke: 'currentColor'
                            }
                        }
                    }}
                >
                    {menuIcon}
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Typography
                            variant={open ? 'h5' : 'body1'}
                            color="inherit"
                            sx={{ my: 'auto' }}
                        >
                            {menu.title}
                        </Typography>
                    }
                    secondary={
                        menu.caption && (
                            <Typography
                                variant="caption"
                                sx={{ ...theme.typography.subMenuCaption }}
                                display="block"
                                gutterBottom
                            >
                                {menu.caption}
                            </Typography>
                        )
                    }
                />
                {open ? (
                    <IconChevronUp
                        stroke={1.5}
                        size="1rem"
                        style={{ marginTop: 'auto', marginBottom: 'auto' }}
                    />
                ) : (
                    <IconChevronDown
                        stroke={1.5}
                        size="1rem"
                        style={{ marginTop: 'auto', marginBottom: 'auto' }}
                    />
                )}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                    component="div"
                    disablePadding
                    className="sidebar-collapse-list"
                    sx={{
                        position: 'relative',
                        '&:after': {
                            content: "''",
                            position: 'absolute',
                            left: '32px',
                            top: 0,
                            height: '100%',
                            width: '1px',
                            opacity: 1,
                            background: theme.palette.primary.light
                        },

                        '& .MuiListItemButton-root': {
                            backgroundColor: 'transparent',
                            color: '#ffffff',

                            '&:hover': {
                                backgroundColor: '#ffffff',
                                color: '#bcbcbc',
                                '& .MuiListItemIcon-root': {
                                    color: '#bcbcbc'
                                }
                            },

                            '&.Mui-selected': {
                                backgroundColor: '#ffffff',
                                color: '#bcbcbc',
                                fontWeight: 600,
                                '& .MuiListItemIcon-root': {
                                    color: '#bcbcbc'
                                },
                                '&:hover': {
                                    backgroundColor: '#ffffff'
                                }
                            }
                        },

                        '& .MuiListItemIcon-root': {
                            color: '#ffffff',
                            '& svg': {
                                fill: 'currentColor',
                                stroke: 'currentColor'
                            }
                        }
                    }}
                >
                    {menus}
                </List>
            </Collapse>
        </>
    );
}

NavCollapse.propTypes = {
    menu: PropTypes.object,
    level: PropTypes.number,
    openCollapse: PropTypes.string,
    setOpenCollapse: PropTypes.func
};

export default NavCollapse;
